import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
/** returns the first promo in publicSessions.promos if any */ export function useCurrentPromo(promoType) {
    var _promos_filter, _this, _currentPromos;
    const { promos } = useContext(SessionContext);
    const currentPromos = (_this = promos) === null || _this === void 0 ? void 0 : (_promos_filter = _this.filter) === null || _promos_filter === void 0 ? void 0 : _promos_filter.call(_this, (i)=>i.type === promoType);
    return currentPromos && (currentPromos.length > 0 ? (_currentPromos = currentPromos) === null || _currentPromos === void 0 ? void 0 : _currentPromos[0] : undefined);
}
